export default function getLocalLineId(
    trackLocalId: string,
    fromPoint: TrackPoint | undefined,
    toPoint: TrackPoint | undefined
) {
    return [
        trackLocalId,
        fromPoint && fromPoint.properties.localId,
        toPoint && toPoint.properties.localId,
    ].join('__');
}
